module.exports = __webpack_public_path__ + "img/pick5.c790fb22.png";